import ColorBox from './ColorBox';

export default ColorBox;
